(async function () {
  'use strict';
  const root = document.querySelector('[data-gp-root]');
  if (!root || !window.GaryPriceStock) return;
  const engine = window.GaryPriceStock;
  const products = JSON.parse(root.querySelector('[data-gp-products]').textContent);
  const copy = JSON.parse(root.querySelector('[data-gp-copy]').textContent);
  const index = new Map(products.flatMap(product => product.variants.map(variant => [String(variant.id), {product, variant}])));
  const route = window.Shopify?.routes?.root || '/';
  let state = {stock: Object.fromEntries(products.flatMap(p => p.variants.map(v => [String(v.id), Math.max(0, v.stock || 0)]))), lines: []};
  async function request(path, body) {
    const response = await fetch(route + path, body ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)} : {cache:'no-store'});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Cart update failed');
    return result;
  }
  async function refresh() {
    const fresh = await request('collections/gary-lee-price?view=gary-availability-data&_=' + Date.now());
    state.stock = Object.fromEntries(fresh.flatMap(p => p.variants.map(v => [String(v.id), Math.max(0, v.stock || 0)])));
    fresh.forEach(p => p.variants.forEach(v => index.set(String(v.id), {product:p,variant:v})));
    const cart = await request('cart.js');
    state.lines = cart.items.filter(i => index.has(String(i.variant_id))).map(i => ({id:String(i.variant_id),quantity:i.quantity,key:i.key,total:i.final_line_price,properties:i.properties}));
  }
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:root.dataset.currency || 'USD', maximumFractionDigits:0}).format(cents / 100);
  const text = (name, values = {}) => Object.entries(values).reduce((s, [k, v]) => s.replaceAll('{'+k+'}', String(v)), copy[name] || '');
  const node = (tag, className, value) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (value !== undefined) el.textContent = value;
    return el;
  };
  const available = () => engine.allocate(state.stock, state.lines).remaining;
  function timing(id, quantity) {
    const gallery = Math.min(quantity, engine.count(available(), id));
    const order = quantity - gallery;
    return gallery && order ? text('split', {gallery, order}) : gallery ? text('ships') : text('delivered');
  }
  function card(product, selected, mode) {
    const card = node('article', 'gp-card' + (mode === 'product' ? ' gp-product-card' : ''));
    card.dataset.productId = product.id;
    const imageLink = node('a');
    const image = node('img', 'gp-image');
    image.loading = mode === 'product' ? 'eager' : 'lazy';
    image.width = 900; image.height = 900;
    imageLink.append(image); card.append(imageLink);
    const details = node('div', 'gp-card-details');
    const title = node('h3');
    const displayTitle = product.title.replace(/^Gary Lee Price\s*-\s*/, '').replace(/\s*\(\d+(?:\.\d+)?[\"”](?:\s*&\s*\d+[\"”])?\)/g, '').replace(/^\"|\"$/g, '');
    const titleLink = node('a', 'gp-title', displayTitle);
    title.append(titleLink); details.append(title);
    const price = node('p', 'gp-price'); details.append(price);
    const unique = mode + '-' + product.id;
    const label = node('label', '', text('size')); label.htmlFor = unique;
    const select = node('select'); select.id = unique;
    product.variants.forEach(v => {
      const option = node('option', '', v.title);
      option.value = v.id; option.selected = String(v.id) === String(selected.id);
      select.append(option);
    });
    if (product.variants.length > 1) details.append(label, select);
    const imageNote = node('p', 'gp-note');
    details.append(imageNote);
    if (product.variants.filter(v => engine.count(state.stock, v.id) > 0).length > 1) details.append(node('p', 'gp-note', text('multiple')));
    const qtyLabel = node('label', '', text('quantity')); qtyLabel.htmlFor = unique + '-qty';
    const qty = node('input'); qty.type = 'number'; qty.id = unique + '-qty'; qty.min = '1'; qty.max = '999'; qty.step = '1'; qty.value = '1';
    details.append(qtyLabel, qty);
    const availability = node('p', 'gp-note');
    const message = node('p', 'gp-timing'); message.setAttribute('aria-live', 'polite');
    const button = node('button', '', text('add')); button.type = 'button';
    const status = node('p', 'gp-note'); status.setAttribute('role', 'status');
    const payment = node('p', 'gp-note');
    details.append(availability, message, button, payment, status);
    card.append(details);
    const update = () => {
      const {variant} = index.get(select.value);
      const n = Number(qty.value);
      const count = engine.count(available(), variant.id);
      const href = product.url + '?variant=' + variant.id + (new URL(location.href).searchParams.get('preview_theme_id') ? '&preview_theme_id=' + new URL(location.href).searchParams.get('preview_theme_id') : '');
      imageLink.href = href; titleLink.href = href;
      image.src = variant.image || product.image || '';
      image.alt = displayTitle + (variant.title === 'Default Title' ? '' : ' — ' + variant.title);
      imageNote.textContent = !variant.image && product.variants.length > 1 ? text('image_note') : '';
      payment.textContent = n > count ? text('payment') : '';
      price.textContent = money(variant.price);
      availability.textContent = count > 0 ? text('gallery_count', {count}) : variant.available ? text('order') : text('unavailable');
      message.textContent = timing(variant.id, engine.validQuantity(n) ? n : 1);
      message.className = 'gp-timing ' + (count > 0 ? 'gp-in-gallery' : 'gp-to-order');
      button.disabled = !engine.validQuantity(n) || !variant.available;
      if (mode === 'product') {
        const url = new URL(location.href); url.searchParams.set('variant', variant.id);
        history.replaceState(null, '', url);
      }
    };
    select.addEventListener('change', update); qty.addEventListener('input', update);
    button.addEventListener('click', async () => {
      if (!engine.validQuantity(qty.value)) return;
      button.disabled = true;
      try {
        await refresh();
        const delivery = timing(select.value, Number(qty.value));
        await request('cart/add.js', {items:[{id:Number(select.value),quantity:Number(qty.value),properties:{'Gary Price delivery':delivery}}]});
        await refresh(); renderCart(); updateCards(); status.textContent = text('added');
      } catch (_) { status.textContent = text('failure'); }
      finally { update(); }
    });
    card.gpUpdate = update;
    update(); return card;
  }
  function updateCards() { root.querySelectorAll('.gp-card').forEach(el => el.gpUpdate()); }
  function renderCatalog() {
    if (root.dataset.mode === 'collection') {
      const gallery = root.querySelector('[data-gallery]'); const order = root.querySelector('[data-order]');
      gallery.replaceChildren(); order.replaceChildren();
      products.forEach(product => {
        const stocked = product.variants.filter(v => engine.count(state.stock, v.id) > 0);
        const ordered = product.variants.filter(v => engine.count(state.stock, v.id) === 0 && index.get(String(v.id)).variant.available);
        if (stocked.length) gallery.append(card(product, engine.largest(stocked), 'gallery'));
        if (ordered.length) order.append(card(product, engine.largest(ordered), 'order'));
      });
      if (!gallery.children.length) gallery.append(node('p', '', text('no_gallery')));
    } else {
      const product = products.find(p => String(p.id) === root.dataset.product);
      if (!product) return;
      const requested = new URL(location.href).searchParams.get('variant');
      const stocked = product.variants.filter(v => engine.count(state.stock, v.id) > 0);
      const selected = product.variants.find(v => String(v.id) === requested) || engine.largest(stocked.length ? stocked : product.variants);
      root.querySelector('[data-product-view]').replaceChildren(card(product, selected, 'product'));
    }
  }
  function renderCart() {
    const container = root.querySelector('[data-cart-lines]'); container.replaceChildren();
    const {allocations} = engine.allocate(state.stock, state.lines);
    if (!allocations.length) container.append(node('p', '', text('empty')));
    allocations.forEach((line, i) => {
      const {product, variant} = index.get(String(line.id));
      const row = node('div', 'gp-cart-row');
      if (root.dataset.mode !== 'cart') row.append(node('h3', '', text('cart_line', {count:line.quantity, title:product.title+' — '+variant.title}))); 
      if (root.dataset.mode !== 'cart') row.append(node('p', 'gp-price', money(line.total))); 
      if (line.gallery) row.append(node('p', 'gp-timing gp-in-gallery', text('cart_gallery', {count:line.gallery})));
      if (line.order) row.append(node('p', 'gp-timing gp-to-order', text('cart_order', {count:line.order})));
      const remove = node('button', '', text('remove')); remove.type = 'button'; remove.setAttribute('aria-label', text('remove')+' '+product.title+' '+variant.title);
      remove.addEventListener('click', async () => {try {await request('cart/change.js',{id:line.key,quantity:0}); await refresh(); renderCart(); updateCards(); if(root.dataset.mode==='cart')location.reload();} catch(_){root.querySelector('[data-cart-status]').textContent=text('failure');}});
      const qty=node('input');qty.type='number';qty.min='1';qty.max='999';qty.value=line.quantity;qty.style.width='90px';qty.setAttribute('aria-label',text('quantity')+' '+variant.title);
      const change=node('button','',text('update'));change.type='button';
      change.addEventListener('click',async()=>{if(!engine.validQuantity(qty.value))return;try{await request('cart/change.js',{id:line.key,quantity:Number(qty.value)});await refresh();renderCart();updateCards();if(root.dataset.mode==='cart')location.reload();}catch(_){root.querySelector('[data-cart-status]').textContent=text('failure');}});
      row.append(qty, change);
      if(root.dataset.mode!=='cart')row.append(remove);
      if(root.dataset.mode==='cart'){
        const target=document.querySelector('[data-gary-row="'+CSS.escape(line.key)+'"]');
        if(target)target.replaceChildren(row);
      }else container.append(row);
    });
  }
  try { await refresh(); } catch (_) { root.querySelector('[data-cart-status]').textContent=text('failure'); }
  renderCatalog(); renderCart();
  document.querySelector('form.cart')?.addEventListener('submit',async event=>{
    if(event.submitter?.name!=='checkout'||!state.lines.length)return;
    event.preventDefault();const form=event.currentTarget;
    try{
      await refresh();renderCart();
      const notes=engine.allocate(state.stock,state.lines).allocations.map(line=>{
        const {product,variant}=index.get(String(line.id));
        return product.title+' — '+variant.title+': '+(line.gallery?text('cart_gallery',{count:line.gallery}):'')+(line.gallery&&line.order?'; ':'')+(line.order?text('cart_order',{count:line.order}):'');
      }).join('\n');
      const allocations=engine.allocate(state.stock,state.lines).allocations;
      let keys=state.lines.map(line=>line.key);
      for(const line of allocations){
        if(!keys.includes(line.key))continue;
        const delivery=line.gallery&&line.order?text('split',{gallery:line.gallery,order:line.order}):line.gallery?text('ships'):text('delivered');
        const changed=await request('cart/change.js',{id:line.key,quantity:line.quantity,properties:{...line.properties,'Gary Price delivery':delivery}});
        keys=changed.items.map(item=>item.key);
      }
      await request('cart/update.js',{attributes:{'Gary Price delivery allocation':notes}});
      const checkout=document.createElement('input');checkout.type='hidden';checkout.name='checkout';checkout.value='Checkout';form.append(checkout);HTMLFormElement.prototype.submit.call(form);
    }catch(_){root.querySelector('[data-cart-status]').textContent=text('failure');}
  });
})();
